/**
 * Home: the headliner map and its list. Everything else lives on the Restaurants and Lists pages.
 */
import { HeadlinerMap } from "@/features/public/components/headliner-map";
import { HEADLINER_LIST_ID } from "@/features/public/headliner";

const HomePage = () => (
  <div className="-mx-4 pb-6 sm:-mx-7">
    <HeadlinerMap source={{ id: HEADLINER_LIST_ID }} heightClassName="h-[50vh] min-h-[300px] md:h-[65vh]" />
  </div>
);

export default HomePage;
